import React from 'react';

import { useSelector } from 'react-redux';

import StaticField from 'components/StaticField';
import { CUSTOMER_BIRTH_DATE } from 'modules/Inquiry/Form/formFields';
import { getCustomerData } from 'store/inquiryDetails/selectors';
import { useTranslations } from 'utils/hooks/useTranslations';

const DateOfBirthStaticField = () => {
  const customerData = useSelector(getCustomerData);

  const t = useTranslations('pages.customerData.sections.contactPerson.fields.dateOfBirth');
  return <StaticField caption={t('caption')} text={customerData[CUSTOMER_BIRTH_DATE]} />;
};

export default DateOfBirthStaticField;
